import React from "react";
import CloseIcon from "../../../../Assets/Icons/CloseIcon.svg";
import FlyerMessage from "../../FlyerMessage";
import "./style.css";

/**
 * A reusable base modal component that serves as a template for other modals.
 * @param {string} title - Title of the modal
 * @param {function} onClose - Function to handle the modal close event
 * @param {ReactNode} children - The content of the modal, provided as child components
 * @param {boolean} showFlyerMessage - Whether to show the FlyerMessage
 * @param {string} flyerMessageText - Text to display in the FlyerMessage
 * @param {function} onFlyerMessageClose - Function to handle FlyerMessage close event

 */

export const BaseModal = ({
  title,
  onClose,
  children,
  showFlyerMessage,
  flyerMessageText,
  onFlyerMessageClose,
}) => {
  return (
    //Modal container with bg opacity
    <div className="modal">
      {showFlyerMessage ? (
        // Render FlyerMessage if showFlyerMessage is true
        <FlyerMessage
          message={flyerMessageText}
          onClose={onFlyerMessageClose}
        />
      ) : (
        // Modal actual frame
        <div className="modal-frame">
          <div className="modal-title-frame">
            {/* Display the modal title */}
            <h6 className="h6-400 white">{title}</h6>
            {/* Close button with an event handler to close the modal */}
            <img
              className="modal-close-icon"
              alt="close-icon"
              src={CloseIcon}
              onClick={onClose}
            />
          </div>
          <div className="modal-content-frame">
            {/* Content of the modal goes here */}
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseModal;
